interface ITrimSaveChanges {
  onCancel: () => void;
  saveChanges: any;
}

export default function TrimSaveChanges({ saveChanges, onCancel }: ITrimSaveChanges) {
  return (
    <div className="transparent font-lato">
      <div className="relative border-x border-t bg-gray-bg-dark border-gray-300  bg-white pb-7 pt-9 px-7 w-screen md:w-[520px] md:min-h-[100px] rounded-t-lg">
        <div className="flex mb-5">
          <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">Save changes?</span>
        </div>
        <p>
          While the video is being edited, you won’t be able to make further edits, and the video won’t be viewable.
        </p>
        <p className="mt-2">The original version of your video will be stored, so you can undo your changes.</p>
      </div>
      <div className="flex text-[13px] pb-6 px-4 bg-white rounded-b-lg border-x">
        <button
          className="py-3 px-8 text-black border border-tabBorder ml-auto rounded-[10px] hover:bg-gray-100"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          className="bg-red-main py-3 px-8 text-white ml-2 rounded-[10px]"
          onClick={async () => {
            await saveChanges();
          }}
        >
          Save changes
        </button>
      </div>
    </div>
  );
}
